<template>
  <div>
    <h3>Add Translational Team</h3>
    <team-form @save-team="addTeam"></team-form>
  </div>
</template>

<script>
import TeamForm from "../../components/translationalteams/team-form";
import translationalTeamsApi from "../../api/translationalTeams";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";

export default {
  data() {
    return {};
  },

  components: {
    "team-form": TeamForm
  },

  methods: {
    addTeam: function(translationalTeam) {
      var that = this;

      translationalTeamsApi
        .postTranslationalTeam(translationalTeam)
        .then(function(response) {
          toastr.options = ToastrSettings;

          // Toastr Message
          toastr.success("The translational team has been saved.", "Success");

          // redirect
          that.$router.push({
            name: "translationalTeam",
            params: { translationalTeamId: response.data }
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
</style>
